import { classNames } from "helpers/commonHelpers";
import AccountMappingRowFields from "./AccountMappingRowFields";
import AccountMappingRowView from "./AccountMappingRowView";
import type { AccountMappingRow as AccountMappingRowType, PaymentLocationOptionsSource } from "./types";

interface AccountMappingRowProps {
  index: number;
  row: AccountMappingRowType;
  isEditing: boolean;
  showLabels: boolean;
  paymentLocationOptions: PaymentLocationOptionsSource;
  selectedPaymentLocations: string[];
  onEdit: () => void;
  onDelete: () => void;
}

export default function AccountMappingRow({
  index,
  row,
  isEditing,
  showLabels,
  paymentLocationOptions,
  selectedPaymentLocations,
  onEdit,
  onDelete,
}: AccountMappingRowProps) {
  const isCreateOrEdit = !row.id || isEditing;

  return (
    <div
      className={classNames("account-mapping-row", {
        "account-mapping-row--view": !isCreateOrEdit,
        "account-mapping-row--edit": isCreateOrEdit,
        "account-mapping-row--has-labels": showLabels,
      })}
      data-account-mapping-row={isEditing ? "editing" : undefined}
      data-testid={row.id ? `account-mapping-row-${row.id}` : `account-mapping-new-row-${index}`}
    >
      {isCreateOrEdit ? (
        <AccountMappingRowFields
          index={index}
          showLabels={showLabels}
          paymentLocationOptions={paymentLocationOptions}
          selectedPaymentLocations={selectedPaymentLocations}
          onDelete={onDelete}
        />
      ) : (
        <AccountMappingRowView row={row} showLabels={showLabels} onEdit={onEdit} onDelete={onDelete} />
      )}
    </div>
  );
}
